import translate from '@translate';
import React, { FC, useEffect, useRef } from 'react';
import Select, { OnChangeType, SelectValueType } from 'src/components/Select';
import { getZasilkovnaFetch } from 'src/resources/zasilkovna/reducer';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';

export interface ZasilkovnaSelectPropsType {
    onChange: OnChangeType;
    value: SelectValueType;
    error?: boolean;
    name?: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
    // Optional Packeta carrierId as string (service code). When provided, UI will request server-filtered points.
    serviceCode?: string;
}

const ZasilkovnaSelect: FC<ZasilkovnaSelectPropsType> = (props) => {
    const dispatch = useDispatch();

    const data = useSelector((state: RootStoreType) => state.zasilkovna.data);
    const loading = useSelector((state: RootStoreType) => state.zasilkovna.loading);

    const carrierId = props.serviceCode ? Number(props.serviceCode) : undefined;
    const prevCarrierId = useRef<number | undefined>(undefined);

    useEffect(() => {
        // Always rely on backend filtering; if carrierId present, send it as payload
        if (carrierId !== prevCarrierId.current) {
            prevCarrierId.current = carrierId;
            dispatch(getZasilkovnaFetch(carrierId));
        } else if (!data) {
            // Fallback for initial load if no carrierId specified
            dispatch(getZasilkovnaFetch(null));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carrierId]);

    const options = data || [];

    const isSet = !props.value || options.filter((option: any): boolean => option.value === props.value).length;
    const allOptions = isSet
        ? options
        : [{ label: `${translate('messages.branchUnavailable')} (${props.value})`, value: props.value }, ...options];

    return (
        <Select
            options={allOptions}
            value={props.value}
            error={props.error}
            onChange={props.onChange}
            name={props.name}
            label={props.label}
            required={props.required}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            loading={loading}
            virtualized
        />
    );
};

export default ZasilkovnaSelect;
